module.exports = __webpack_public_path__ + "media/country_flags/lu-16b42be3.png";